import { useController } from 'react-hook-form';
import { Checkbox, CheckboxProps } from 'ui/checkboxV2';
import { FieldProps } from './types';

type CheckboxV2FieldProps = FieldProps & Omit<CheckboxProps, 'status' | 'setChecked'>;

export const CheckboxV2Field = ({ name, ...rest }: CheckboxV2FieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue: false,
  });

  return (
    <Checkbox {...rest} name={name} status={value} setChecked={(checked) => onChange(checked)} />
  );
};
